export * from './toolbar';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/@angular/material/toolbar/index.js
// module id = ../../../material/toolbar/index.js
// module chunks = 3